/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-10-10 14:42:22
 */

import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '../app/store'
import fetchHelper from '../utils/fetchHelper'
import { capturePromiseException } from '../utils/sentryUtils'
import { VERIFY_AUTH_DEFAULT_CONFIG } from '../constants/verify'
import type {
  VerifyImage,
  VerifyResult,
  VerifyAuthConfig
} from '../pages/verifyAuth/types'

// 声明 Vite define 定义的全局变量
declare const __API_SERVER_HOST__: string

interface VerifyAuthState {
  needVerifyImages: VerifyImage[]
  verifyResult: VerifyResult[]
  config: VerifyAuthConfig
}

const initialState: VerifyAuthState = {
  needVerifyImages: [],
  verifyResult: [],
  config: VERIFY_AUTH_DEFAULT_CONFIG
}

export const fetchVerifyAuthConfig = createAsyncThunk(
  'verifyAuth/fetchVerifyAuthConfig',
  async (data, { dispatch, getState, rejectWithValue }) => {
    try {
      const config = {
        url: __API_SERVER_HOST__ + '/web/truthful/page_view/query',
        arguments: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            platform: 'web'
          })
        }
      }
      const result = await fetchHelper(dispatch, getState, config)
      const {
        data: { status, needUpdate, version, config: resultConfig }
      } = result
      if (status === 0) {
        console.log('fetchVerifyAuthConfig: ', JSON.parse(resultConfig))
        return JSON.parse(resultConfig)
      }
      return rejectWithValue('请求失败')
    } catch (error) {
      capturePromiseException(error)
      return rejectWithValue('网络错误')
    }
  }
)

const verifyAuthSlice = createSlice({
  name: 'verifyAuth',
  initialState,
  reducers: {
    setNeedVerifyImages: (state, action: PayloadAction<VerifyImage[]>) => {
      state.needVerifyImages = action.payload
    },
    setVerifyResult: (state, action: PayloadAction<VerifyResult[]>) => {
      state.verifyResult = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVerifyAuthConfig.fulfilled, (state, action) => {
        state.config = action.payload
      })
      .addCase(fetchVerifyAuthConfig.rejected, (state, action) => {
        state.config = VERIFY_AUTH_DEFAULT_CONFIG
      })
  }
})

export const { setNeedVerifyImages, setVerifyResult } = verifyAuthSlice.actions

export const selectVerifyAuthConfig = (state: RootState) =>
  state.verifyAuth.config
export const selectNeedVerifyImages = (state: RootState) =>
  state.verifyAuth.needVerifyImages
export const selectVerifyResult = (state: RootState) =>
  state.verifyAuth.verifyResult

export default verifyAuthSlice.reducer
